export default {"src":"/_next/static/media/calendar-frame-mobile.2268dc12.svg","height":44,"width":41,"blurWidth":0,"blurHeight":0};